<template>
  <div class="constants-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex> \$2\$ </div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage light-stage">
        <div class="hud-panel">
          <div class="hud-item cyan" v-for="c in constants" :key="c.name" 
               v-show="activeTab === c.id"
               :class="c.color">
             <label>{{ c.chineseName }} ({{ c.symbol }})</label>
             <span class="val">{{ c.value }} {{ c.unit }}</span>
          </div>
        </div>

        <div class="comparison-stage">
           <!-- 抽选展示 c (光速) 演示：环绕地球 -->
           <div v-if="activeTab === 'c'" class="anim-box">
              <svg width="100%" height="200" viewBox="0 0 400 200">
                <circle cx="200" cy="100" r="40" fill="#3b82f6" />
                <text x="200" y="105" text-anchor="middle" fill="#fff" font-size="10">地球</text>
                <circle :cx="lightPos.x" :cy="lightPos.y" r="4" fill="#fbbf24" filter="url(#glow)">
                   <animateTransform attributeName="transform" type="rotate" from="0 200 100" to="360 200 100" dur="0.13s" repeatCount="indefinite" />
                </circle>
                <defs><filter id="glow"><feGaussianBlur stdDeviation="2.5" result="coloredBlur"/><feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
              </svg>
              <div class="desc-text-center">光速在一秒内可绕地球约 <strong>7.5 圈</strong></div>
           </div>

           <!-- 抽选展示 G (引力) 演示：扭秤 -->
           <div v-if="activeTab === 'G'" class="anim-box">
              <svg width="100%" height="200" viewBox="0 0 400 200">
                <line x1="200" y1="20" x2="200" y2="150" stroke="#64748b" stroke-width="1" />
                <circle cx="150" cy="150" r="10" fill="#334155" />
                <circle cx="250" cy="150" r="10" fill="#334155" />
                <circle cx="120" cy="150" r="25" fill="#94a3b8" opacity="0.5" />
                <circle cx="280" cy="150" r="25" fill="#94a3b8" opacity="0.5" />
              </svg>
              <div class="desc-text-center">卡文迪许通过极微弱的<strong>引力耦合</strong>“称量”了地球</div>
           </div>
        </div>

        <div class="physics-caption">
          <strong>物理描述：</strong>物理常数是宇宙演化的遗传密码。它们决定了原子的尺寸、恒星的寿命乃至时空的曲率。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row"><span class="label">选择常数进行深度解析</span></div>
           <div class="btn-group-row">
              <el-button v-for="c in constants" :key="c.id" 
                         :type="activeTab === c.id ? 'primary' : 'info'" size="mini" plain
                         @click="activeTab = c.id">{{ c.chineseName }}</el-button>
           </div>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-medal"></i>
           <p><strong>实战物理：</strong>普朗克常数 $h$ 是量子世界的门槛。<strong>注意：</strong>如果常数稍微改变，宇宙将不复存在。例如：光速 $c$ 减半，你将能肉眼观察到相对论时空收缩效应。本组件旨在培养你的<strong>量纲直觉</strong>。
           </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'PhysicsConstantsViz',
  data() {
    return {
      activeTab: 'c',
      lightPos: { x: 260, y: 100 },
      constants: [
        { id: 'c', symbol: 'c', chineseName: '光速', value: '299,792,458', unit: 'm/s', color: 'cyan' },
        { id: 'h', symbol: 'h', chineseName: '普朗克常数', value: '6.626×10^-34', unit: 'J·s', color: 'rose' },
        { id: 'G', symbol: 'G', chineseName: '引力常数', value: '6.674×10^-11', unit: 'N·m²/kg²', color: 'orange' },
        { id: 'e', symbol: 'e', chineseName: '元电荷', value: '1.602×10^-19', unit: 'C', color: 'emerald' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.constants-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
.comparison-stage { flex: 1; display: flex; align-items: center; justify-content: center; position: relative; }
.anim-box { text-align: center; width: 100%; }
.desc-text-center { font-size: 13px; color: #64748b; margin-top: 10px; }
.btn-group-row { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 8px; }
</style>
